import { render, staticRenderFns } from "./MixDetail.vue?vue&type=template&id=77753e28"
import script from "./MixDetail.vue?vue&type=script&lang=js"
export * from "./MixDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports